const lookupOptions = [
    {
        name: 'Top Tokens (ERC20)',
        value: 'tokens'
    },
    {
        name: 'Tokens Transfers (ERC20)',
        value: 'tokentxns'
    },
    { type: 'divider' },
    {
        name: 'Top NFTs',
        value: 'nft-top-contracts'
    },
    {
        name: 'Latest Transfers',
        value: 'nft-transfers'
    },
    {
        name: 'Latest Mints',
        value: 'nft-latest-mints'
    }
]

module.exports = { lookupOptions }
